<template>
  <div id="app">
    <top-bar />
    <side-bar />
        <!-- ============================================================== -->
        <!-- Page wrapper  -->
        <!-- ============================================================== -->
        <div class="page-wrapper">
  
          <!-- ============================================================== -->
          <!-- Container fluid  -->
          <!-- ============================================================== -->
          <div class="container-fluid col-md-10 col-lg-11">
                <!--<notifications />-->
                <router-view />
          </div>
          <!-- ============================================================== -->
          <!-- End Container fluid  -->
          <!-- ============================================================== -->

            <!-- ============================================================== -->
            <!-- footer -->
            <!-- ============================================================== -->
            <footer class="footer">
            <footer-bar />
				{{productName}} voor FM Module, weet wat werkt!
			</footer>
            <!-- ============================================================== -->
            <!-- End footer -->
            <!-- ============================================================== -->
        </div>
        <!-- ============================================================== -->
        <!-- End Page wrapper  -->
        <!-- ============================================================== -->
  </div>
</template>

<script>
import TopBar from "./components/root/TopBar";
import SideBar from "./components/root/SideBar";
import FooterBar from "./components/root/FooterBar";
import { productInfo } from '@/mixins/productInfo';

export default {
  mixins: [productInfo],
  components: {
    TopBar,
    SideBar,
    FooterBar
  },
  computed: {
    productName() {
        return "FM Beheer"
    }        
  },
  async created() {
    document.title = this.productName;
    document.querySelector("#loaderLabel").innerHTML = this.productName;

    try {
      await this.$auth.renewTokens();
    } catch {
      // Supress the 'not logged in' error as we can illegitimately get that
      // when processing the callback url
    }
  }
};
</script>
